import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { scrollToAnchor } from '../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './TermsOfSalesPage.scss';

class TermsOfSalesPage extends React.Component {
    componentDidMount() {
        scrollToAnchor(this.props.location);
    }

    componentDidUpdate() {
        scrollToAnchor(this.props.location);
    }

    render() {
        const { i18n } = this.props;

        return (
            <main className="conteneur conteneur-mobile" id="p-cgv">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.TERMS_OF_SALES}`}
                />
                <LocalizedBreadcrumbItem to={PATH.TERMS_OF_SALES}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.TITLE}</h1>

                <h3>{i18n.TITLE1}</h3>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT1_1)}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT1_2)}</p>
                <p>{i18n.TEXT1_3}</p>
                <p>{i18n.TEXT1_4}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT1_5)}</p>

                <h3>{i18n.TITLE2}</h3>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT2_1)}</p>
                <p>{i18n.TEXT2_2}</p>
                <p>{i18n.TEXT2_3}</p>

                <h3>{i18n.TITLE3}</h3>
                <p>{i18n.TEXT3_1}</p>
                <p>{i18n.TEXT3_2}</p>

                <h3>{i18n.TITLE4}</h3>
                <p>{i18n.TEXT4_1}</p>
                <p>{i18n.TEXT4_2}</p>

                <h3>{i18n.TITLE5}</h3>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT5_1)}</p>
                <p>{i18n.TEXT5_2}</p>
                <p>{i18n.TEXT5_3}</p>

                <h3>{i18n.TITLE6}</h3>
                <p>
                    <b>{i18n.TEXT6_1}</b>
                </p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT6_2)}</p>
                <p>{i18n.TEXT6_3}</p>
                <p>
                    <b>{i18n.TEXT6_4}</b>
                </p>
                <p>{i18n.TEXT6_5}</p>
                <p>{i18n.TEXT6_6}</p>
                <p>{i18n.TEXT6_7}</p>
                <ul>
                    <li>{i18n.TEXT6_8}</li>
                    <li>{i18n.TEXT6_9}</li>
                </ul>

                <h3>{i18n.TITLE7}</h3>
                <p>
                    <b>{i18n.TEXT7_1}</b>
                </p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT7_2)}</p>

                <h3>{i18n.TITLE8}</h3>
                <p>{i18n.TEXT8_1}</p>

                <h3>{i18n.TITLE9}</h3>
                <p>{i18n.TEXT9_1}</p>
                <p>{i18n.TEXT9_2}</p>
                <p>{i18n.TEXT9_3}</p>
                <p>{i18n.TEXT9_4}</p>

                <h3>{i18n.TITLE10}</h3>
                <p>{i18n.TEXT10_1}</p>
                <p>{i18n.TEXT10_2}</p>
                <p>{i18n.TEXT10_3}</p>
                <p>{i18n.TEXT10_4}</p>
                <p>{i18n.TEXT10_5}</p>
            </main>
        );
    }
}

TermsOfSalesPage.propTypes = {
    i18n: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.TERMS_OF_SALES
    };
}

export default withTemplate(connect(mapStateToProps)(TermsOfSalesPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/termsofsales/TermsOfSalesPage.js